import * as React from 'react';
import {Icon} from '@flexe/ui-components';
import {PickBatchDocument} from '../WaveInterfaces';

export enum PrintButtonTextOption {
  longFormat,
  shortFormat
}

interface Props {
  className?: string;
  document?: PickBatchDocument;
  isWaveCancelled: boolean;
  printButtonText: PrintButtonTextOption;
}

const DocumentPrintButton = ({className, document, isWaveCancelled, printButtonText}: Props) => {
  const handlePrintButtonClick = () => {
    if (document && !isWaveCancelled) {
      window.open(`/wh/logged_document/${document.id}`, '_blank').focus();
    }
  };

  const isReprint = document?.views.length > 0;

  const buttonText = (): string => {
    switch (printButtonText) {
      case PrintButtonTextOption.longFormat:
        return isReprint ? 'Reprint All Documents' : 'Print All Documents';
      case PrintButtonTextOption.shortFormat:
        return isReprint ? 'Reprint' : 'Print';
    }
  };

  const buttonClassName = (): string => {
    const names = [className, 'document-print-button'];
    if (isReprint) {
      names.push('reprint');
    } else {
      names.push('print');
    }
    return names.join(' ').trim();
  };

  return (
    <button
      className={buttonClassName()}
      key="print-btn"
      onClick={handlePrintButtonClick}
      disabled={!document || isWaveCancelled}
    >
      {document || isWaveCancelled ? (
        buttonText()
      ) : (
        <>
          <span className="creating-labels-icon-container">
            <Icon icon="circle-notch" animation="spin-fast" />
          </span>
          Creating Labels...
        </>
      )}
    </button>
  );
};

export default DocumentPrintButton;
